const model = {
    submitting: false,
    errors: null,
    sizeDetails: null,
    success: false,
};

export default model;
